import type { AllRouteEndpoints } from "../routeTypes";
export const companiesCompanyIdDevelopersDeveloperIdSuspendCacheKeys: AllRouteEndpoints[] = [
  "/companies/:company_id/developers",
  "/companies/:company_id/developers/table",
];
